// extracted by mini-css-extract-plugin
export default {"grid":"tags_grid__WlZxQ"};